"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.default = exports.Spotlight = void 0;
require("./Spotlight.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Spotlight component
 *
 * @method
 * @param { SpotlightProps} props
 * @returns Spotlight
 */

const Spotlight = props => {
  const {
    externalGraphicImage,
    eyebrow,
    subtitle,
    textAlign,
    title
  } = props;
  if (!eyebrow || !subtitle || !title) {
    return null;
  }
  const hasMedia = !!externalGraphicImage;
  const componentClassName = (0, _classnames.default)('pal-c-Spotlight', {});
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, hasMedia && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Spotlight__horizontalLine"
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _renderObject.renderObject)(externalGraphicImage))), /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Spotlight__contentWrapper"
  }, eyebrow && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Spotlight__eyebrow"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "eyebrow",
    htmlTag: "p",
    textAlign: textAlign
  }, eyebrow)), title && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Spotlight__title"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "title",
    htmlTag: "h2",
    textAlign: textAlign
  }, title)), subtitle && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Spotlight__subtitle"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "displayBody-sm",
    htmlTag: "p",
    textAlign: textAlign
  }, subtitle))));
};

/**
 * Property type definitions
 * @typedef SpotlightProps
 * @type {object}
 * @property {object} externalGraphicImage - url, altText, ratio and loading prop for external image or
 * @property {string} eyebrow - eyebrow text
 * @property {string} subtitle - Subtitle text
 * @property {string} textAlign - Where the text content should align horizontally
 * @property {string} title - title text
 */
exports.Spotlight = Spotlight;
const propTypes = exports.propTypes = {
  /**
   * External image or video sent with with business logic or links
   */
  externalGraphicImage: _propTypes.default.object,
  /**
   * Smaller text above the title
   */
  eyebrow: _propTypes.default.string,
  /**
   * Decorative image string for bridge card
   */
  image: _propTypes.default.string,
  /**
   * Basic text usually used as a subtitle of the card
   */
  subtitle: _propTypes.default.string,
  /**
   * Where the text content should align horizontally
   */
  textAlign: _propTypes.default.string,
  /**
   * Sets the title of the header
   */
  title: _propTypes.default.string
};
Spotlight.propTypes = propTypes;
var _default = exports.default = Spotlight;